import { useState } from 'react'

import Validation from 'src/components/Validation'

// Declarative field validation hook ported from donate_v6/useValidation.js.
// Pass a `fieldSet` of rules (required, minLength, maxLength, format, etc.)
// at construction time; call validate(dataset) before submission and
// resetErrorsFor(field) on each onChange to clear an error as the user
// fixes it.

const useValidation = ({ i18n, currency, ...config }) => {
  const [ errors, setErrors ] = useState({})

  const validate = dataset => {
    const validation = Validation(i18n, currency)
    const { valid, errors } = validation.validate(dataset, config)
    setErrors(errors)
    return valid
  }

  const addError = (field, error) =>
    setErrors(errors =>
      ({ ...errors, [field]: (errors?.[field] || []).concat(error) })
    )

  const resetErrorsFor = field =>
    setErrors(errors =>
      errors?.[field]?.length ? { ...errors, [field]: null } : errors
    )

  return { errors, setErrors, validate, addError, resetErrorsFor }
}

export default useValidation
